<template>
  <TabsContent v-bind="forwarded">
    <slot />
  </TabsContent>
</template>

<script setup>
import { TabsContent, useForwardPropsEmits } from 'radix-vue';

const props = defineProps({
  as: {
    type: String,
    required: false,
    default: 'div',
  },
  asChild: {
    type: Boolean,
    required: false,
    default: false,
  },
  forceMount: {
    type: Boolean,
    required: false,
    default: false,
  },
  value: {
    type: String,
    required: true,
  },
});

const emits = defineEmits([]);

const forwarded = useForwardPropsEmits(props, emits);
</script>
